import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a45301"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-vistor-result" }
const _hoisted_2 = { class: "result-title" }
const _hoisted_3 = { class: "result-remark-label" }
const _hoisted_4 = { class: "result-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "审批结果：" + _toDisplayString(_ctx.resultVal), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.reasonLabel), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_van_cell_group, { inset: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            modelValue: _ctx.message,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
            rows: "2",
            autosize: "",
            type: "textarea",
            maxlength: "200",
            placeholder: _ctx.placeholderVal,
            "show-word-limit": ""
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_van_button, {
        type: "primary",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode("提交")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}